import { Pencil, Trash2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { DialogHeader, DialogTitle } from '@/components/ui/dialog'

import { StatusBadge } from '@/components/atoms'

import { ProductModel } from '@/types/model/Product'

interface ProductViewHeaderProps {
  product: ProductModel.Product
  onEdit: (product: ProductModel.Product) => void
  onDelete: (product: ProductModel.Product) => void
}

export const ProductViewHeader = ({ product, onEdit, onDelete }: ProductViewHeaderProps) => {
  return (
    <DialogHeader className="px-5 pb-0 pt-5">
      <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-start">
        <div className="min-w-0 space-y-1">
          <DialogTitle className="truncate">{product.name}</DialogTitle>
          <div className="flex flex-wrap items-center gap-2">
            <StatusBadge type="product" status={product.status} />
            <span className="text-xs text-muted-foreground">ID: {product._id}</span>
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => onEdit(product)}>
            <Pencil />
            Edit
          </Button>
          <Button variant="destructive" onClick={() => onDelete(product)}>
            <Trash2 />
            Delete
          </Button>
        </div>
      </div>
    </DialogHeader>
  )
}
